import { z } from "zod"

export type useValidationReturnType<T extends Record<string, any>> = {
  status: 'failed' | 'success'
  errors: Partial<Record<keyof T, string>>
}
// Хелпер для извлечения типа из Zod схемы
type ZodInfer<T extends z.ZodTypeAny> = z.infer<T>
//hook below returns results of data validation
export const useValidation  = <T extends z.ZodTypeAny> (schema: T, data: unknown): useValidationReturnType<ZodInfer<T>> => {
  const validation = schema.safeParse(data)
  console.log('validation', validation)

  const errors: Partial<Record<keyof ZodInfer<T>, string>> = {}
  if (!validation.success) {
    validation.error.issues.forEach(({ path, message }) => {
      const key = path[0] as keyof ZodInfer<T>
      errors[key] = message
    })
    return { status: 'failed', errors }
  }
  return {status: 'success', errors: {}}
}